import { render, staticRenderFns } from "./d-profile-expandable-biography.vue?vue&type=template&id=b37a6102&scoped=true&"
import script from "./d-profile-expandable-biography.vue?vue&type=script&lang=js&"
export * from "./d-profile-expandable-biography.vue?vue&type=script&lang=js&"
import style0 from "./d-profile-expandable-biography.vue?vue&type=style&index=0&id=b37a6102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37a6102",
  null
  
)

export default component.exports